import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { initialState } from './dataModel';
import { RootStoreType } from '../rootReducer';
import { SchemaApiValue, TrainedModel } from '../../@shared/Models/Models';

const statesSlice = createSlice({
    name: 'dataReducer',
    initialState: initialState.dataModel,
    reducers: {
        setIsModelsLoading: (state, action: PayloadAction<boolean>) => {
            state.isModelsLoading = action.payload;
        },
        setIsTrainedModelsLoading: (state, action: PayloadAction<boolean>) => {
            state.isTrainedModelsLoading = action.payload;
        },
        setOpenedModelId: (state, action: PayloadAction<string>) => {
            state.openedModelId = action.payload;
        },
        setPage: (state, action: PayloadAction<number>) => {
            state.page = action.payload;
        },
        setSchemas: (state, action: PayloadAction<SchemaApiValue[]>) => {
            state.models = action.payload;
        },
        addOrUpdateTopSchemas: (state, action: PayloadAction<SchemaApiValue[]>) => {
            state.topSchemas = action.payload;
        },
        setIsLoadingTopSchemas: (state, action: PayloadAction<boolean>) => {
            state.isLoadingTopSchemas = action.payload;
        },
        setOpenedSchema: (state, action: PayloadAction<SchemaApiValue | undefined>) => {
            state.openedSchema = action.payload;
        },
        setIsLoadingOpenedSchema: (state, action: PayloadAction<boolean>) => {
            state.isLoadingOpenedSchema = action.payload;
        },

        setOpenedSchemaModels: (state, action: PayloadAction<TrainedModel[] | undefined>) => {
            state.openedSchemaModels = action.payload;
        },
        setIsLoadingOpenedSchemaModels: (state, action: PayloadAction<boolean>) => {
            state.isLoadingOpenedSchemaModels = action.payload;
        },
        setIsSchemaWasRemoved: (state, action: PayloadAction<boolean>) => {
            state.isSchemaWasRemoved = action.payload;
        },
        setOpenedModel: (state, action: PayloadAction<TrainedModel | undefined>) => {
            state.openedModel = action.payload;
        },
        setIsLoadingOpenedModel: (state, action: PayloadAction<boolean>) => {
            state.isLoadingOpenedModel = action.payload;
        },
        setIsModelWasRemoved: (state, action: PayloadAction<boolean>) => {
            state.isModelWasRemoved = action.payload;
        },
        setIsModelDuplicatedTo: (state, action: PayloadAction<string | undefined>) => {
            state.isModelDuplicatedTo = action.payload;
        },
        setCountOfSchemas: (state, action: PayloadAction<number>) => {
            state.countOfSchemas = action.payload;
        },
        setPageCount: (state, action: PayloadAction<number>) => {
            state.pageCount = action.payload;
        },
        setSearchValue: (state, action: PayloadAction<string>) => {
            state.searchValue = action.payload;
        },
    }
});

export const {
    setSchemas,
    setIsModelsLoading,
    setIsTrainedModelsLoading,
    setOpenedModelId,
    addOrUpdateTopSchemas,
    setIsLoadingTopSchemas,
    setOpenedSchema,
    setIsLoadingOpenedSchema,
    setOpenedSchemaModels,
    setIsLoadingOpenedSchemaModels,
    setIsSchemaWasRemoved,
    setOpenedModel,
    setIsLoadingOpenedModel,
    setIsModelWasRemoved,
    setIsModelDuplicatedTo,
    setCountOfSchemas,
    setPageCount,
    setPage,
    setSearchValue
} = statesSlice.actions;

//selectors
export const getSchemas = (store: RootStoreType): SchemaApiValue[] | undefined => store.data.dataModel.models;
export const getTopSchemas = (store: RootStoreType): SchemaApiValue[] | undefined => store.data.dataModel.topSchemas;
export const getIsTrainedModelsLoading = (store: RootStoreType): boolean => store.data.dataModel.isTrainedModelsLoading;
export const getIsModelsLoading = (store: RootStoreType): boolean => store.data.dataModel.isModelsLoading;
export const getOpenedModelId = (store: RootStoreType): string => store.data.dataModel.openedModelId;
export const getPage = (store: RootStoreType): number => store.data.dataModel.page;
export const getIsLoadingTopSchemas = (store: RootStoreType): boolean => store.data.dataModel.isLoadingTopSchemas;
export const getOpenedSchema = (store: RootStoreType): SchemaApiValue | undefined => store.data.dataModel.openedSchema;
export const getIsLoadingOpenedSchema = (store: RootStoreType): boolean => store.data.dataModel.isLoadingOpenedSchema;
export const getOpenedSchemaModels = (store: RootStoreType): TrainedModel[] | undefined => store.data.dataModel.openedSchemaModels;
export const getIsLoadingOpenedSchemaModels = (store: RootStoreType): boolean => store.data.dataModel.isLoadingOpenedSchemaModels;
export const getIsSchemaWasRemoved = (store: RootStoreType): boolean => store.data.dataModel.isSchemaWasRemoved;
export const getOpenedModel = (store: RootStoreType): TrainedModel | undefined => store.data.dataModel.openedModel;
export const getIsLoadingOpenedModel = (store: RootStoreType): boolean => store.data.dataModel.isLoadingOpenedModel;
export const getIsModelWasRemoved = (store: RootStoreType): boolean => store.data.dataModel.isModelWasRemoved;
export const getIsModelDuplicatedTo = (store: RootStoreType): string | undefined => store.data.dataModel.isModelDuplicatedTo;
export const getCountOfSchemas = (store: RootStoreType): number => store.data.dataModel.countOfSchemas;
export const getPageCount = (store: RootStoreType): number => store.data.dataModel.pageCount;
export const getSearchValue = (store: RootStoreType): string => store.data.dataModel.searchValue;

export default statesSlice.reducer;